<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, toRefs, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import {useUserStore} from "../../../stores/user";
import {useMyPageLectDetailStore} from "../../../stores/mypage/mypageLectDetailStore";
import _ from 'lodash';

export default {
  name: "LectureRegCompleteModal",
  components: {
    Modal,
  },
  setup() {
    const baseModal = ref(null);
    const resolvePromise = ref(null);

    const show = () => {
      baseModal.value.open();
      return new Promise((resolve, _) => {
        resolvePromise.value = resolve;
      });
    };

    const confirm = () => {
      baseModal.value.close();
      resolvePromise.value(true);
    };

    const cancel = () => {
      baseModal.value.close();
      resolvePromise.value(false);
    };

    return { baseModal, show, confirm, cancel};
  },
};
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner lg-size">
      <div class="modal-body">
        <h3>개인정보의 수집·이용·제공 및 활용에 동의<span class="red">(필수)</span></h3>
        <!-- <p class="mt-sm">
          <b>본 강의는 <span class="blue">비수도권 소재 담당 교육기관에서 진행</span>됩니다</b><br/>
          개인정보의 수집·이용·제공 및 활용에 대한 약관을 확인하신 후 동의해주세요.
        </p> -->
        <div class="terms-wrap">
          <div class="terms-box">
            <b>1. 수집하는 개인정보 항목</b><br/>
            회사는 회사가 주최 및 주관하는 채용지원시스템의 채용 입사 지원을 위한 개인정보 확인 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br/><br/>

            &nbsp;&nbsp;&nbsp;- 이름, 핸드폰 번호, 이메일, 거주지역, 학력, 학교, 전공, 성적증명서, 포트폴리오(수상작, 논문, 프로젝트 결과물 등), 자격증 및 외국어 능력, 업무 경험(경력 정보), 병역 유무 등<br/><br/>

            <b>2. 정보의 이용 목적 및 제공 범위</b><br/>
            회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br/><br/>

            &nbsp;&nbsp;&nbsp;- 회원 관리 회원제 서비스 이용에 따른 본인 확인, 개인 식별, 채용지원시스템 이용 확인, 문의사항 처리 및 공지사항 전달<br/>
            &nbsp;&nbsp;&nbsp;- 채용지원시스템 채용 공고 확인 및 입사 지원을 위한 개인 이력 정보 제공 목적<br/>
            &nbsp;&nbsp;&nbsp;- 채용지원시스템 이용 기업 회원들에게 제공되는 개인 이력 정보 노출을 위한 목적<br/><br/>

            <b>3. 정보 보유 및 이용기간 </b><br/>
            회사는 수집한 개인정보를 이용목적이 달성된 후에는 회원탈퇴 및 회원정보삭제 요청시까지 보유하고 탈퇴 및 삭제요청 이후에는 해당 정보를 지체 없이 파기합니다.<br/><br/>
          </div>
        </div>
        <!-- <b>동의하지 않을 시 수강신청을 할 수 없습니다.</b> -->
      </div>
      <div class="modal-footer">
        <KSASecondaryButton class="full-btn" text="동의하지 않음" @click="cancel" />
        <KSAPrimaryButton class="full-btn" text="동의" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.modal-inner {
  width: 564px !important;
  padding: 20px 10px !important;
  .modal-body {
    h3 {
      font-size: $font-size_xl !important;
      line-height: $line-height_lg !important;
      text-align:left !important;
    }
    .terms-wrap {
      margin: 20px 0 0 0;
      text-align: left;

      .terms-box {
        height: 280px;
        overflow-y: auto;
        @include font-size_xs;
        background: $gray-thin_color;
        border: $border_line;
        padding: 20px;
        margin: 10px 0 40px;
      }
    }
  }

  .modal-footer {
    button { 
      width: 150px !important;
    }
  }
}
</style>